import React from 'react';
import { type MobileBottomNavItem } from '@cx-web/api-clients/nav-api/types';
import Icon from '@cx-web/components/primitives/icon';
import { useLoaderData, useLocation } from '@remix-run/react';

import { mergePersistentParams } from '@cx-modules/utils';

import { useServicesContext } from '~/providers/services-context';

import styles from '../../MobileBottomNav.module.css';
import { handleEvent } from '../../utils/handleEvent';

interface NavLinkProps {
  item: MobileBottomNavItem;
}

export const NavLink = ({ item }: NavLinkProps) => {
  const location = useLocation();
  const loaderData = useLoaderData<{ url?: string }>();
  const { trackingActions } = useServicesContext();
  const [icon, dimension = '20'] = (item.icon || '').split(',');
  const isSelected = item.link === location.pathname;
  const requestUrl = typeof window !== 'undefined' ? window.location.href : loaderData?.url;

  return (
    <li
      aria-label={item.name}
      className={`${styles.menuItem} ${isSelected ? styles.active : ''}`}
      data-testid="mobile-bottom-nav-item"
      onClick={() => handleEvent(item.name, trackingActions)}
    >
      <a href={mergePersistentParams(item.link || '', requestUrl)}>
        {icon && (
          <span className={styles.iconContainer}>
            <Icon height={parseInt(dimension, 10)} icon={icon} width={parseInt(dimension, 10)} />
            {item.count ? <span className={styles.offerCount}>{item.count}</span> : null}
          </span>
        )}
        {item.name}
      </a>
    </li>
  );
};
